import axios from 'axios'
import { $sso } from '../main'
import { getHost } from '../vue-apollo'

export const exportExcel = async ({ name, sheets }) => {
  const filename = `${name}.xlsx`

  const resp = await axios({
    url: `${getHost()}/api/1/xlsx`,
    method: 'POST',
    responseType: 'arraybuffer',
    headers: {
      Authorization: `Bearer ${$sso.bearerToken}`
    },
    data: {
      name,
      sheets
    }
  })

  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(resp.data, filename)
  } else {
    const a = document.createElement('a')
    const url = window.URL.createObjectURL(
      new Blob([resp.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
    )
    a.href = url
    a.target = '_blank'
    a.download = filename
    document.body.appendChild(a)
    a.click()
  }
}
